import script from "./Statement.vue?vue&type=script&setup=true&lang=js"
export * from "./Statement.vue?vue&type=script&setup=true&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=2a163c5e&lang=css"

const __exports__ = script;

export default __exports__